module.exports = __webpack_public_path__ + "static/img/mobile-web-img-01@m.639309f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/d-steady/mobile-web-img-01@m.png
// module id = yV9J
// module chunks = 0